import React from 'react';
import {
  Modal,
  FormGroup,
  FormControl,
  InputGroup,
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setUserLocation, setLocationSelected } from '../../dashboard/actions';
import { getUserLocation, getDataName } from '../../dashboard/reducer';
import { SearchAvailableAddress } from '../../../api/searchForAddress';
import { getJWT, getTokenId } from '../../../redux/reducers/authenticationReducers';
import { get } from 'lodash';
import Loader from 'react-loader-spinner';
import { MdLoaderTheme } from '../../common/Loading';
import { GeolocationsErrors } from '../../../util/Errors';
import { getAlertifyHeader } from '../../../../src/lib/helper';
import defaultMsg from '../../../translations/lang/en-US.json';

var alertify = require('alertifyjs');

class UserLocation extends React.Component {
  constructor(props) {
    super(props);
    this.findUserLocations = this.findUserLocations.bind(this);
    this.state = {
      noRestaurantNearBy: false,
      isGeoLocationAvailable: navigator.geolocation,
      lookingForGeoLocation: false,
      searchingRestaurants: false,
      locate: this.props.intl.formatMessage({
        id: 'whatIsYourAddress',
        defaultMessage: defaultMsg.whatIsYourAddress,
      }),
    };
    this.browserGeolocationMessage = this.browserGeolocationMessage.bind(this);
  }

  handleChange(e) {
    this.setState({ locate: e.target.value });
    if (e.which === 13) {
      this.findUserLocations(this.userLocation.value);
    }
  }

  locateUserLocation() {
    this.setState({
      lookingForGeoLocation: true,
      noRestaurantNearBy: false,
    });
    this.userLocation.value = '';
    navigator.geolocation.getCurrentPosition(
      position => {
        const google = window.google;
        const geocoder = new google.maps.Geocoder();
        var location = new google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude
        );
        geocoder.geocode({ latLng: location }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            this.userLocation.value = results[0].formatted_address;
            this.findUserLocations(results[0].formatted_address);
            this.setState({
              lookingForGeoLocation: false,
            });
          } else {
            let geocodeMsg =
              this.props.intl.formatMessage({
                id: 'geocodeError',
                defaultMessage: defaultMsg.geocodeError,
              }) +
              ':' +
              status;
            this.browserGeolocationMessage(geocodeMsg);
          }
        });
      },
      error => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            this.browserGeolocationMessage(GeolocationsErrors.access_denied);
            break;
          case error.POSITION_UNAVAILABLE:
            this.browserGeolocationMessage(
              GeolocationsErrors.location_unavailable
            );
            break;
          case error.TIMEOUT:
            this.browserGeolocationMessage(GeolocationsErrors.timeout);
            break;
          case error.UNKNOWN_ERROR:
            this.browserGeolocationMessage(GeolocationsErrors.unknown_error);
            break;
        }
        this.setState({
          lookingForGeoLocation: false,
        });
      }
    );
  }

  browserGeolocationMessage = errorMsg => {
    const messageBody = `
      <div class="text-center order-success-container">
      <h4>${errorMsg}</h4>
      </div>
    `;
    alertify.alert(
      getAlertifyHeader(
        this.props.intl.formatMessage({
          id: 'browserGeolocation',
          defaultMessage: defaultMsg.browserGeolocation,
        }),
        false,
        'left'
      ),
      messageBody
    );
  };

  componentDidMount() {
    let locate = this.props.intl.formatMessage({
      id: 'whatIsYourAddress',
      defaultMessage: defaultMsg.whatIsYourAddress,
    });
    if (
      this.props.userSelectedLocation &&
      this.props.userSelectedLocation !== ''
    ) {
      locate = this.props.userSelectedLocation;
      this.setState({ locate: locate });
    }
    const google = window.google;
    var autocomplete = new google.maps.places.Autocomplete(this.userLocation);
    autocomplete.addListener('place_changed', () =>
      this.findUserLocations(this.userLocation.value)
    );
  }

  findUserLocations(streetAddress) {
    this.setState({
      numberOfRestaurantNearBy: false,
      searchingRestaurants: true,
      noRestaurantNearBy: false,
    });
    const { dataname, jwt, tokenId, rname } = this.props;
    SearchAvailableAddress({
      streetAddress,
      dataname,
      diningOption: '',
      jwt,
      tokenId,
      rname,
    }).then(apiResponse => {
      this.props.onSelectLocation(true);
      const restaurantNearByToUserLocations = get(
        apiResponse,
        'data.DataResponse.sourceaddress',
        false
      );
      if (restaurantNearByToUserLocations.length) {
        this.props.actions.setLocationSelected(streetAddress);
        localStorage.setItem('userSelectedLocation', streetAddress);
        this.props.actions.setUserLocation({
          address: streetAddress,
          availableRestaurant: restaurantNearByToUserLocations,
        });
      } else {
        this.props.actions.setUserLocation({
          address: streetAddress,
          availableRestaurant: {},
        });
      }
    });
  }

  render() {
    const themeColor = '#' + this.props.themeCode;
    const locatingUserLocation = this.props.intl.formatMessage({
      id: 'locatingYourLocation',
      defaultMessage: defaultMsg.locatingYourLocation,
    });
    return (
      <div>
        <Modal show={true} dialogClassName="modal-lg">
          <Modal.Header>
            <h4 className="modal-title">
              <FormattedMessage
                id="userLocationHeader"
                defaultMessage={defaultMsg.userLocationHeader}
              />
            </h4>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <InputGroup>
                <FormControl
                  inputRef={ref => {
                    this.userLocation = ref;
                  }}
                  type="text"
                  placeholder={
                    this.state.lookingForGeoLocation
                      ? locatingUserLocation
                      : this.state.locate
                  }
                  readOnly={this.state.lookingForGeoLocation}
                  onChange={e => this.handleChange}
                />
                {this.state.isGeoLocationAvailable ? (
                  <InputGroup.Addon
                    onClick={() => this.locateUserLocation()}
                    className="cursonPointer"
                  >
                    {this.state.lookingForGeoLocation ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="locate-user-location">
                            {locatingUserLocation}
                          </Tooltip>
                        }
                      >
                        <i
                          className="fa fa-spinner fa-spin "
                          aria-hidden="true"
                        />
                      </OverlayTrigger>
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="locate-user-location">
                            {' '}
                            <FormattedMessage
                              id="locateMe"
                              defaultMessage={defaultMsg.locateMe}
                            />
                          </Tooltip>
                        }
                      >
                        <i
                          className="fa fa-location-arrow cursonPointer"
                          aria-hidden="true"
                        />
                      </OverlayTrigger>
                    )}
                  </InputGroup.Addon>
                ) : null}
              </InputGroup>
            </FormGroup>
            {this.state.noRestaurantNearBy ? (
              <div className="text-center text-danger">
                <FormattedMessage
                  id="restaurantNotFound"
                  defaultMessage={defaultMsg.restaurantNotFound}
                />
              </div>
            ) : null}
            {this.state.searchingRestaurants ? (
              <div className="text-center text-muted">
                <MdLoaderTheme />
              </div>
            ) : null}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userLocation: getUserLocation(state),
  dataname: getDataName(state),
  jwt: getJWT(state),
  tokenId: getTokenId(state),
  userSelectedLocation: state.dashboard.userSelectedLocation,
  dataComplete: state.dashboard,
  themeCode: state.dashboard.merchantDetails.lavu_togo_theme,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setUserLocation,
      setLocationSelected,
    },
    dispatch
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(UserLocation));



// WEBPACK FOOTER //
// ./src/views/orderType/components/UserLocation.jsx